import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

// Staff Summary - PDF
const exportStaffPDF = (filteredStaff) => {
  const doc = new jsPDF();
  doc.text("Staff Summary", 14, 10);

  filteredStaff.forEach((staff) => {
    autoTable(doc, {
      startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 20,
      head: [
        [
          "Staff Name",
          "Staff No",
          "Total",
          "Today Paid",
          "Month Paid",
          "Month Unpaid",
        ],
      ],
      body: [
        [
          staff.staff_name,
          staff.staff_no,
          staff.total_count,
          staff.current_date_paid_count,
          staff.current_month_paid_count,
          staff.current_month_unpaid_count,
        ],
      ],
    });

    if (staff.areas && staff.areas.length > 0) {
      autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 5,
        head: [
          [
            "Area Name",
            "Box Count",
            "Today Paid",
            "Month Paid",
            "Month Unpaid",
          ],
        ],
        body: staff.areas.map((a) => [
          a.area_name,
          a.box_count,
          a.current_date_paid_count,
          a.current_month_paid_count,
          a.current_month_unpaid_count,
        ]),
      });
    }
  });

  doc.save("Staff_Summary.pdf");
};

// Staff Summary - Excel
const exportStaffExcel = (filteredStaff) => {
  let excelData = [];

  filteredStaff.forEach((staff) => {
    excelData.push({
      "Staff Name": staff.staff_name,
      "Staff No": staff.staff_no,
      "Total Box Count": staff.total_count,
      "Today Paid Box": staff.current_date_paid_count,
      "Month Paid Box": staff.current_month_paid_count,
      "Month Unpaid Box": staff.current_month_unpaid_count,
      "Area Name": "",
      "Area Box Count": "",
      "Area Today Paid": "",
      "Area Month Paid": "",
      "Area Month Unpaid": "",
    });

    staff.areas.forEach((a) => {
      excelData.push({
        "Staff Name": "",
        "Staff No": "",
        "Total Box Count": "",
        "Today Paid Box": "",
        "Month Paid Box": "",
        "Month Unpaid Box": "",
        "Area Name": `→ ${a.area_name}`,
        "Area Box Count": a.box_count,
        "Area Today Paid": a.current_date_paid_count,
        "Area Month Paid": a.current_month_paid_count,
        "Area Month Unpaid": a.current_month_unpaid_count,
      });
    });

    excelData.push({});
  });

  const ws = XLSX.utils.json_to_sheet(excelData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Staff Summary");
  XLSX.writeFile(wb, "Staff_Summary.xlsx");
};

// User Summary - PDF
const exportUserPDF = (filteredUsers) => {
  const doc = new jsPDF();
  doc.text("User Summary", 14, 10);

  filteredUsers.forEach((user) => {
    autoTable(doc, {
      startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 20,
      head: [
        ["User Name", "Total", "Today Paid", "Month Paid", "Month Unpaid"],
      ],
      body: [
        [
          user.name,
          user.total_count,
          user.current_date_paid_count,
          user.current_month_paid_count,
          user.current_month_unpaid_count,
        ],
      ],
    });

    if (user.areas && user.areas.length > 0) {
      autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 5,
        head: [
          [
            "Area Name",
            "Box Count",
            "Today Paid",
            "Month Paid",
            "Month Unpaid",
          ],
        ],
        body: user.areas.map((a) => [
          a.area_name,
          a.box_count,
          a.current_date_paid_count,
          a.current_month_paid_count,
          a.current_month_unpaid_count,
        ]),
      });
    }
  });

  doc.save("User_Summary.pdf");
};

// User Summary - Excel
const exportUserExcel = (filteredUsers) => {
  let excelData = [];

  filteredUsers.forEach((user) => {
    excelData.push({
      "User Name": user.name,
      "Total Box Count": user.total_count,
      "Today Paid Box": user.current_date_paid_count,
      "Month Paid Box": user.current_month_paid_count,
      "Month Unpaid Box": user.current_month_unpaid_count,
      "Area Name": "",
      "Area Box Count": "",
      "Area Today Paid": "",
      "Area Month Paid": "",
      "Area Month Unpaid": "",
    });

    user.areas.forEach((a) => {
      excelData.push({
        "User Name": "",
        "Total Box Count": "",
        "Today Paid Box": "",
        "Month Paid Box": "",
        "Month Unpaid Box": "",
        "Area Name": `→ ${a.area_name}`,
        "Area Box Count": a.box_count,
        "Area Today Paid": a.current_date_paid_count,
        "Area Month Paid": a.current_month_paid_count,
        "Area Month Unpaid": a.current_month_unpaid_count,
      });
    });

    excelData.push({});
  });

  const ws = XLSX.utils.json_to_sheet(excelData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "User Summary");
  XLSX.writeFile(wb, "User_Summary.xlsx");
};

export { exportStaffPDF, exportStaffExcel, exportUserPDF, exportUserExcel };
